import { css as e, cx as r } from "@leafygreen-ui/emotion";
import { useIdAllocator as t } from "@leafygreen-ui/hooks";
import n, { useState as i, useEffect as o } from "react";
import a from "prop-types";
function l(e, r, t) {
  return (r = function (e) {
    var r = function (e, r) {
      if ("object" != typeof e || null === e) return e;
      var t = e[Symbol.toPrimitive];
      if (void 0 !== t) {
        var n = t.call(e, r || "default");
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof r ? r : String(r);
  }(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function u() {
  return u = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, u.apply(this, arguments);
}
function c(e, r) {
  if (null == e) return {};
  var t,
    n,
    i = function (e, r) {
      if (null == e) return {};
      var t,
        n,
        i = {},
        o = Object.keys(e);
      for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) >= 0 || (i[t] = e[t]);
      return i;
    }(e, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
  }
  return i;
}
function f(e, r) {
  return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
function s(e, r) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, r) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != t) {
      var n,
        i,
        o,
        a,
        l = [],
        u = !0,
        c = !1;
      try {
        if (o = (t = t.call(e)).next, 0 === r) {
          if (Object(t) !== t) return;
          u = !1;
        } else for (; !(u = (n = o.call(t)).done) && (l.push(n.value), l.length !== r); u = !0);
      } catch (e) {
        c = !0, i = e;
      } finally {
        try {
          if (!u && null != t.return && (a = t.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw i;
        }
      }
      return l;
    }
  }(e, r) || function (e, r) {
    if (!e) return;
    if ("string" == typeof e) return p(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === t && e.constructor && (t = e.constructor.name);
    if ("Map" === t || "Set" === t) return Array.from(e);
    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return p(e, r);
  }(e, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function p(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];
  return n;
}
var d;
function m(r) {
  return null != r && "string" == typeof r ? e(d || (d = f(["\n      @media (prefers-reduced-motion: reduce) {\n        ", "\n      }\n    "])), r) : "";
}
var b = function (e) {
  var r = t({
      prefix: "lgui-input",
      id: e
    }),
    n = t({
      prefix: "lgui-label"
    });
  return {
    labelProps: {
      id: n,
      htmlFor: r
    },
    inputProps: l({
      id: r
    }, "aria-labelledby", n)
  };
};
function y() {
  var e = s(i(!1), 2),
    r = e[0],
    t = e[1],
    n = function (e) {
      t(e.matches);
    };
  return o(function () {
    if (window && window.matchMedia && "function" == typeof window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion: reduce)");
      return t(e.matches), e.addEventListener("change", n), function () {
        return e.removeEventListener("change", n);
      };
    }
  }, []), r;
}
function v(e, r) {
  e["aria-label"] || e["aria-labelledby"] || console.error("For screen-reader accessibility, aria-label or aria-labelledby must be provided".concat(r ? " to ".concat(r) : "", "."));
}
var h,
  g = ["children", "className"],
  w = e(h || (h = f(["\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n"])));
function O(e) {
  var t = e.children,
    i = e.className,
    o = c(e, g);
  return n.createElement("div", u({}, o, {
    className: r(w, i)
  }), t);
}
O.displayName = "VisuallyHidden", O.propTypes = {
  children: a.string,
  className: a.string
};
export { O as VisuallyHidden, m as prefersReducedMotion, b as useAccessibleForm, y as usePrefersReducedMotion, v as validateAriaLabelProps };